import Vue from "vue";
import App from "./App.vue";
import store from './store'
import "normalize.css";
import "./styles/main.scss";
import router from './router/index'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faCopy, faBars, faTimes, faPencilAlt, faTrash, faPrint, faUser, faArrowLeft,
  faFileInvoice, faCheck, faCogs, faCaretLeft, faCaretUp, faCaretDown, faList, faKey
} from '@fortawesome/free-solid-svg-icons'

Vue.config.productionTip = false;

library.add(faCopy, faBars, faTimes, faPencilAlt, faTrash, faPrint, faUser, faCaretUp, faCaretDown,
  faArrowLeft, faFileInvoice, faCheck, faCogs, faCaretLeft, faList, faKey)
Vue.component('font-awesome-icon', FontAwesomeIcon)

new Vue({
  store,
  router,
  render: (h) => h(App)
}).$mount("#app");
